import { noneProfile } from "assets";
import ImageUrl from "components/app/image-url/ImageUrl";
import { BookUser, Loader, LoaderCircle } from "lucide-react";

import InfiniteScroll from "react-infinite-scroll-component";
import { Popover, PopoverContent, PopoverTrigger } from "components/ui/popover";
import NumberInput from "components/app/function/NumberInput";
import { Button } from "components/ui/button";
import SkeletonMusicLibrariesTable from "pages/account-detail/music-libraries/skeleton/SkeletonMusicLibrariesTable";
import { useDispatch } from "react-redux";
import { setIndexTimeSheet } from "store/header";
import { Service } from "utils/services";
const LeaveTable = ({
  shopEmployeeLeave,
  fetchMoreShopEmployeeLeaveSearch,
  shopEmployeeLeaveLoading,
  listRef,
  selectProducts,
  setSelectedProductIds,
  selectedProductIds,
  setOpenDrawer,
  getShopEmployeeLeaveDetail,
  openPopoverKey,
  setOpenPopoverKey,
  setMonthTableClick,
  monthDay,
  handleChangeMonth,
  saveUpdateLeaveDeduction,
  loadingsubmitUpdateLeaveDeduction,
  shopEmployeeLeaveLoadingState,
  setMonthTable,
}: any) => {
  const dispatch = useDispatch();
  return (
    <InfiniteScroll
      dataLength={shopEmployeeLeave?.data?.length || 0}
      next={() =>
        fetchMoreShopEmployeeLeaveSearch({
          next: shopEmployeeLeaveLoading.nextPageUrl,
        })
      }
      scrollThreshold="90%"
      hasMore={!!shopEmployeeLeaveLoading.nextPageUrl}
      scrollableTarget="scrollableDiv"
      loader={
        <div className="absolute bottom-2 left-0 w-full flex justify-center mt-5">
          <LoaderCircle size={30} className="animate-spin text-yellow-400" />
        </div>
      }
    >
      <>
        {shopEmployeeLeaveLoadingState ? (
          <SkeletonMusicLibrariesTable />
        ) : (
          <table className="min-w-full border-collapse mb-20 rounded-md overflow-hidden">
            <thead className="sticky top-0 left-0 text-xs text-gray-700  bg-gray-300 dark:bg-[#2c3a52] dark:text-gray-400">
              <tr className="border-none text-[15px] text-start ">
                <th className=" py-5 px-4 first:rounded-tl-md last:rounded-tr-md ">Image</th>
                <th className="px-4 text-start ">Staff Name </th>
                <th className="px-4 text-start">Department</th>
                <th className="px-4 text-start">Type</th>
                <th className="px-4 text-end">Jan</th>
                <th className="px-4 text-end">Feb</th>
                <th className="px-4 text-end">Mar</th>
                <th className="px-4 text-end">Apr</th>
                <th className="px-4 text-end">May</th>
                <th className="px-4 text-end">Jun</th>
                <th className="px-4 text-end">Jul</th>
                <th className="px-4 text-end">Aug</th>
                <th className="px-4 text-end">Sep</th>
                <th className="px-4 text-end">Oct</th>
                <th className="px-4 text-end">Nov</th>
                <th className="px-4 text-end">Dec</th>
              </tr>
            </thead>
            <tbody ref={listRef}>
              {shopEmployeeLeave?.data?.map((item: any, index: number) => {
                return (
                  <tr
                    onClick={() => {
                      if (selectProducts) {
                        setSelectedProductIds((prev: any) => (prev.includes(item.id) ? prev.filter((id: any) => id !== item.id) : [...prev, item.id]));
                        return;
                      } else {
                        dispatch(setIndexTimeSheet(item.id));
                      }
                    }}
                    key={index}
                    className={`text-center group cursor-pointer ${index % 2 === 0 ? "bg-gray-100 dark:bg-[#1e293b] " : "bg-gray-200 dark:bg-[#2c3a52] "} hover:bg-gray-300`}
                  >
                    <td className="relative w-[100px] h-[100px]">
                      <div
                        className={` ${
                          selectedProductIds.includes(item.id) ? "bg-white" : ""
                        } w-4 h-4 rounded-full flex items-center z-50 justify-center absolute left-[6px] top-[6px] text-xl  ${!selectProducts ? " hidden" : " block"}`}
                      >
                        {selectedProductIds.includes(item.id) ? (
                          <i className=" fa-solid  fa-circle-check text-blue-500 border-2 rounded-full border-white  "></i>
                        ) : (
                          <i className=" fa-regular fa-circle text-blue-500 border-2 border-transparent rounded-full"></i>
                        )}
                      </div>
                      <div
                        onClick={() => {
                          getShopEmployeeLeaveDetail(item?.employee_id, item?.leave_type);

                          setOpenDrawer(1);
                        }}
                        className={`${
                          selectProducts ? " hidden" : " block"
                        } z-50 cursor-pointer group-hover:scale-110 transition-all duration-300 group-hover:opacity-100 opacity-0 w-8 h-8 flex items-center justify-center bg-green-500 text-white p-2 rounded-full absolute right-2 top-2`}
                      >
                        <BookUser />
                      </div>
                      <ImageUrl src={!item.picture ? noneProfile : item.picture} className="w-[100px] h-[100px] z-1 mx-auto relative" alt="" />
                    </td>
                    <td className="py-2 px-4 text-md text-left align-top">
                      <p className="text-[15px] font-bold ">{item.card_no}</p>

                      <p className="text-[15px] ">{item.local_name}</p>
                      <p className="text-md">{item.english_name}</p>
                    </td>

                    <td className="py-2 px-4 text-md  text-left align-top ">
                      <p className="text-md line-clamp-1 "> {item?.department}</p>
                      <p className="text-md "> {item?.position}</p>
                      <div className="flex items-center gap-1 text-muted-foreground">
                        <p className="text-md text-nowrap"> {Service.formatTime(item?.starting_time)}</p>
                        {item?.starting_time && item?.ending_time && "-"}
                        <p className="text-md text-nowrap "> {Service.formatTime(item?.ending_time)}</p>
                      </div>
                    </td>
                    <td className="py-2 px-4 text-left align-top">
                      <p
                        className={` text-white px-2 my-1 inline-block rounded-md py-1 ${
                          item.leave_type === "Annual Leave" ? "bg-green-500" : item.leave_type === "Sick Leave" ? "bg-[#a657f6]" : "bg-red-700"
                        } font-semibold text-sm  line-clamp-1`}
                      >
                        {item.leave_type.replace(/-/g, " ")}
                      </p>
                      <p className="font-bold  text-[15px]  text-yellow-500  ">{item.no_of_day > 0 ? item.no_of_day + " days" : ""} </p>
                    </td>
                    {["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"].map((month, monthIndex) => (
                      <td key={month} className="py-2 px-4  text-[15px] text-nowrap text-end align-top">
                        {/* --- Used Day Popover --- */}
                        <Popover
                          open={openPopoverKey?.row === index && openPopoverKey?.month === `${month}-used`}
                          onOpenChange={(isOpen) => setOpenPopoverKey(isOpen ? { row: index, month: `${month}-used` } : null)}
                        >
                          <PopoverTrigger asChild>
                            <p
                              onClick={() => {
                                if (selectProducts) {
                                  return;
                                } else {
                                  setMonthTable(monthIndex + 1);
                                  setMonthTableClick(true);
                                }
                              }}
                              className="text-[15px] font-semibold text-nowrap "
                            >
                              {item[`${month}_used_day`] !== "0.000" ? <p className="text-red-500">{item[`${month}_used_day`]}</p> : "-"}
                            </p>
                          </PopoverTrigger>
                          <PopoverContent className="w-auto">
                            <div className="grid gap-4">
                              <div className="space-y-2">
                                <h4 className="font-medium leading-none">Used Day</h4>
                              </div>
                              <div className="flex items-center gap-2">
                                <NumberInput
                                  className="w-[150px]"
                                  value={monthDay[`${index}-${month}`] || ""}
                                  onChange={(val: any) => handleChangeMonth(`${index}-${month}`, val.target.value)}
                                />
                                <Button
                                  className="px-5 dark:text-white"
                                  onClick={() => {
                                    saveUpdateLeaveDeduction(`${index}-${month}`, item.id, false);
                                  }}
                                >
                                  {loadingsubmitUpdateLeaveDeduction ? <Loader className="animate-spin" /> : "Save"}
                                </Button>
                              </div>
                            </div>
                          </PopoverContent>
                        </Popover>

                        {/* --- End Day Popover --- */}
                        <p className="text-[15px] font-semibold text-nowrap cursor-pointer  ">
                          {item[`${month}_end_day`] !== "0.000" ? <p className="text-blue-500">{item[`${month}_end_day`]}</p> : "-"}
                        </p>
                      </td>
                    ))}
                  </tr>
                );
              })}
              {!shopEmployeeLeave?.next_page_url ? (
                <p className="absolute bottom-0 left-0 w-full text-center mb-5 flex items-center justify-center">
                  <b>Nothing more to load!</b>
                </p>
              ) : (
                ""
              )}
            </tbody>
          </table>
        )}
      </>
    </InfiniteScroll>
  );
};

export default LeaveTable;
